import React from "react";
import GeneralSettingsTab from "../../../component/general-settings/GeneralSettingsTab";

function IPSettings() {
  return (
    <div className="page-body">
      <GeneralSettingsTab />
    </div>
  );
}

export default IPSettings;
